import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import cityList from '@swf/generated/cz/cities.json';
import regionList from '@swf/generated/cz/districts.json';
import municipalityList from '@swf/generated/cz/municipalities.json';

interface City extends SelectOption {
  id: string;
  region: string;
}

interface District extends SelectOption {
  parts: SelectOption[];
}

interface Municipality {
  id: number;
  city: string;
  region: number;
  districts: District[];
}

const cities = cityList as City[];
const municipalities = municipalityList as Municipality[];
const regions = regionList as SelectOption[];

export const getCities = (regionValue: string) => {
  const regionId = regions.find(({ value }) => value === regionValue)?.value;
  return cities.filter(({ region }: City) => region === regionId);
};

export const getDistricts = (cityValue: string, regionValue: string) => {
  const regionId = regions.find(({ value }) => value === regionValue)?.value;
  return (
    municipalities.find(({ city, region }) => city === cityValue && region === Number(regionId))
      ?.districts || []
  );
};

export const getParts = (cityValue: string, districtValue: string, regionValue: string) => {
  const districts = getDistricts(cityValue, regionValue);
  return districts?.find(({ value }) => value === +districtValue)?.parts || [];
};

export const getRegions = () => regions;
